import { Injectable } from '@angular/core';

import { EmailLog } from '@osos/shared/api';
import { EmailLogPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../../bases/factory/factory-base';
import { EmailParserV1Service } from '../../../parsers';
import { ParserFactory } from '../../../services';

@Injectable()
export class EmailEntryFactoryService extends FactoryBase<
  EmailLog,
  EmailLogPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: EmailParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: EmailLogPresenterModel): EmailLog {
    const parser = this.getParser(EmailLog, EmailLogPresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(model: EmailLog): EmailLogPresenterModel {
    const parser = this.getParser(EmailLog, EmailLogPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
